var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.86,226.9a1.34,1.34,0,0,0,0-.2,23.11,23.11,0,0,0-1.12-7.15A83.54,83.54,0,0,0,289.7,211a20.12,20.12,0,0,0-9.12-12.11,7.53,7.53,0,0,0-.9-.56.82.82,0,0,0-.2-.12l-.21-.11c-5.7-3.14-12.11-1.67-17,.56a15.86,15.86,0,0,0-6.15,4.92,24.55,24.55,0,0,0-4.44,7.86,23.43,23.43,0,0,0-3.4,25.21,33.74,33.74,0,0,0,.29,3.62c0,.16.24.13.24,0,0-.85,0-1.69,0-2.53q.45.82,1,1.62c0,.42,0,.83,0,1.24,0,.58.86,1.21,2.32,1.84a23.44,23.44,0,0,0,35.19-.54,23.61,23.61,0,0,0,4.1-2.44c.63-.47.83-3,.65-6.54a19.31,19.31,0,0,0,.56-2.53c.28,2.63.5,5.27.71,7.91,0,.19.3.17.3,0A113.11,113.11,0,0,0,292.86,226.9Zm-7.77-23.37c-.21-.31-.44-.61-.66-.9a24.43,24.43,0,0,1,5.27,10.53c.26,1,.5,2.06.72,3.09a23.39,23.39,0,0,0-1.28-2.23h0C288,209.63,286.65,205.76,285.09,203.53Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.87,149.8a23.44,23.44,0,1,1-35.37-20.17c1.09-3.5,3.91-6.83,10.2-8.41,12.31-3.07,15,5.81,15.3,6.77a0,0,0,0,1,0,0h0a0,0,0,0,1,0,0,34.19,34.19,0,0,1,1.09,3.48A23.32,23.32,0,0,1,302.87,149.8Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.37,
    cy: 139.93,
    r: 35.6,
    transform: "translate(-37.46 235.62) rotate(-80.52)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.01,
    cy: 140.72,
    r: 33.97,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.01,
    cy: 140.72,
    r: 31.83,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 111.21,
    width: 0.61,
    height: 4.82,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.15,
    y: 114.84,
    width: 0.62,
    height: 4.82,
    transform: "translate(-44.09 69.93) rotate(-30)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.22,
    y: 124.76,
    width: 0.61,
    height: 4.82,
    transform: "translate(-60.87 148.91) rotate(-60)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.49,
    y: 140.41,
    width: 4.82,
    height: 0.62,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.12,
    y: 153.97,
    width: 4.82,
    height: 0.61,
    transform: "translate(-63.94 69.95) rotate(-30.01)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.04,
    y: 163.89,
    width: 4.82,
    height: 0.62,
    transform: "translate(-87.96 176.13) rotate(-60.03)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 165.41,
    width: 0.61,
    height: 4.82,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.25,
    y: 161.78,
    width: 0.62,
    height: 4.82,
    transform: "translate(-63.94 89.77) rotate(-30)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.17,
    y: 151.86,
    width: 0.61,
    height: 4.82,
    transform: "translate(-60.87 203.11) rotate(-60)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.7,
    y: 140.41,
    width: 4.82,
    height: 0.62,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.07,
    y: 126.86,
    width: 4.82,
    height: 0.61,
    transform: "translate(-44.1 89.79) rotate(-30)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.15,
    y: 116.94,
    width: 4.82,
    height: 0.62,
    transform: "translate(-33.73 176.12) rotate(-60.03)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.71,
    y: 144.12,
    width: 30.8,
    height: 0.61,
    transform: "translate(-63.08 185.99) rotate(-63.03)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.41,
    y: 129.61,
    width: 0.82,
    height: 30.33,
    transform: "translate(-26.02 26.92) rotate(-11.32)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjP0--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.75,117.86c-.78-.49-1.45-1.2-2.5-1.1-.4,0-.31-.29-.31-.51,0-3.92,0-7.85,0-11.77a.64.64,0,0,1,.33-.68c3-1.51,4.29-4.48,6.13-7a11.71,11.71,0,0,0,2.17-8.9c-.12-.89.29-1.28,1.09-1.46a2,2,0,0,1,2.23.7,15.76,15.76,0,0,1,1.72,5.14c.17,1.49-.36,2.94-.55,4.41-.14,1.08-.39,2.15-.59,3.24.26.19.57.09.85.09h9.94c1.4,0,2.08.4,2.28,1.32a2.67,2.67,0,0,1-1.45,2.88c-.24.12-.69,0-.72.4s.43.35.66.51c1.2.83,1,2.52-.41,3.5-.34.24-1,.13-1,.62s.6.39.87.66c1,1,.49,2.75-1,3.47a5.77,5.77,0,0,0-.58.22c-.17.11-.33.24,0,.46,1.44,1,1.41,2.46,0,3.5l-.43.31a2.84,2.84,0,0,1-1.75.38q-7.78,0-15.59,0A1.83,1.83,0,0,1,212.75,117.86Z",
    style: {
      fill: "#dbdbdb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,110.94c0-2.49,0-5,0-7.48,0-.5,0-.75.67-.75,3.05,0,6.08,0,9.12,0,.6,0,.69.2.69.73q0,7.51,0,15c0,.63-.17.82-.81.8-2.95,0-5.9,0-8.84,0-.74,0-.84-.25-.83-.89C198,115.93,198,113.44,198,110.94Z",
    style: {
      fill: "#dbdbdb",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjp0--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.55,223.87c.78.49,1.46,1.2,2.5,1.1.4,0,.31.29.32.51v11.77c0,.28,0,.52-.32.68-3,1.51-4.3,4.48-6.14,7a11.75,11.75,0,0,0-2.17,8.9c.13.89-.29,1.28-1.08,1.46a2,2,0,0,1-2.24-.7,15.74,15.74,0,0,1-1.71-5.14c-.18-1.49.36-2.94.54-4.41.14-1.08.39-2.14.6-3.24-.27-.19-.57-.09-.85-.09h-9.95c-1.4,0-2.08-.4-2.27-1.32a2.66,2.66,0,0,1,1.44-2.88c.25-.12.7,0,.73-.4s-.44-.35-.66-.51c-1.2-.83-1-2.52.41-3.5.33-.24,1-.13,1-.62s-.59-.39-.87-.66c-1-1-.48-2.75,1-3.47a4.37,4.37,0,0,0,.58-.22c.17-.11.33-.24,0-.46-1.43-1-1.4-2.46,0-3.5l.43-.31a2.84,2.84,0,0,1,1.75-.38q7.8,0,15.59,0A1.83,1.83,0,0,1,427.55,223.87Z",
    style: {
      fill: "#dbdbdb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.33,230.79c0,2.49,0,5,0,7.48,0,.5,0,.75-.67.75q-4.56-.06-9.12,0c-.6,0-.69-.2-.69-.73,0-5,0-10,0-15.05,0-.63.17-.81.81-.8,2.95,0,5.9,0,8.85,0,.73,0,.83.25.83.89C442.31,225.8,442.33,228.29,442.33,230.79Z",
    style: {
      fill: "#dbdbdb",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.81,284.69V422h83V284.69Zm75.45,86.61H299.34V335.57h67.92Zm0-44.24H299.34V291.33h67.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.79,
    y: 284.69,
    width: 33.18,
    height: 137.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.35,
    y: 291.32,
    width: 16.14,
    height: 35.73,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.76,413.84H299.27V378.78h68.49Zm-67.49-1h66.49V379.78H300.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.98,
    y: 388.86,
    width: 13.4,
    height: 6.78,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.85,395.63H327.44v-6.76h14.41Zm-13.41-1h12.41v-4.76H328.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.35,
    y: 335.57,
    width: 16.14,
    height: 35.73,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.51 421.79 124.95 421.55 169.38 421.46 258.26 421.3 347.13 421.46 391.57 421.55 436.01 421.79 391.57 422.04 347.13 422.13 258.26 422.29 169.38 422.13 124.95 422.04 80.51 421.79",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.7,
    cy: 445.04,
    rx: 141.93,
    ry: 16.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.32,
    cy: 445.04,
    rx: 70.9,
    ry: 9.26,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puff--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4,444.33l164,.71c39.86-31.31,44-77.69,15.54-105.8-17.21-17-39.07-13.57-59.88-16.28H204c-7.25-.94-14.36-2.63-21.11-6.19-21.43-11.31-33.51-38-51.54-60.41-2.25-2.81-4.6-5.55-7.06-8.18-14.83-15.83-44.34-16.35-59.77,5.91C25.32,310.63,43.29,394.8,84.4,444.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.76,314.94c4.3,67.29,82,92.41,130.55,72.25,42.2-17.53,28.39-57.53-7.23-64.23H204c-7.25-.94-14.36-2.63-21.11-6.19-21.43-11.31-33.51-38-51.54-60.41C104.51,242.4,77.61,265.67,80.76,314.94Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.07,439.79c-2.27-.83-53.56-41.83-54.53-44.63-.38-1.06,5.16-8.88,12.12-18.14,1.5-2,3.06-4,4.66-6.13,10.37-13.51,21.68-27.6,21.68-27.6l34.39,27.33-22.62,26.84-5,5.9s12.62,24.48,13.35,27.66S219.34,440.62,217.07,439.79Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,439.79c-2.27-.83-53.56-41.83-54.53-44.63-.45-1.29,7.81-12.57,16.78-24.27l33.45,26.57-5,5.9s12.62,24.48,13.35,27.66S219.34,440.62,217.07,439.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,439.79c-2.27-.83-53.56-41.83-54.53-44.63-.38-1.06,5.16-8.88,12.12-18.14l33.14,26.34s12.62,24.48,13.35,27.66S219.34,440.62,217.07,439.79Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,437.15c-8.43-7.08-43.1-34.86-52-41.22-.08-.05-.11,0,0,.06,8.2,7.2,43.1,34.69,51.9,41.3C218.05,437.43,218.15,437.3,218,437.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33,426.54a8.83,8.83,0,0,0-6.82-2,8.51,8.51,0,0,0-5.59,3.06c0,.05.05.13.1.08a10.22,10.22,0,0,1,12.22-1A.07.07,0,0,0,219.33,426.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,406.88c-3.41-2.8-8.37-4.77-12.76-3.67-.17.05-.1.29,0,.32a61.06,61.06,0,0,1,12.44,3.82A.28.28,0,0,0,210.46,406.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28,410c-3.4-2.8-8.36-4.77-12.75-3.67-.17.05-.1.29,0,.32A61.25,61.25,0,0,1,212,410.51.27.27,0,0,0,212.28,410Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.11,413.2c-3.4-2.8-8.36-4.77-12.75-3.67-.17,0-.11.29,0,.31a61.63,61.63,0,0,1,12.43,3.83A.28.28,0,0,0,214.11,413.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.94,416.36c-3.4-2.8-8.36-4.77-12.75-3.67-.17,0-.11.28,0,.31a61,61,0,0,1,12.43,3.83A.28.28,0,0,0,215.94,416.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,389.51c-3.87-3.07-8.65,2.94-4.78,6S178.6,392.59,174.72,389.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.51,400.67c-.58-2.84-3.91-3.18-6.18-2.54a23.14,23.14,0,0,0-10.16,6.3.12.12,0,0,0,0,.19.53.53,0,0,0,.4.77c3.8.26,7.84,1,11.61.1C219.41,405,222.07,403.35,221.51,400.67Zm-10.06,3.94c-1.88-.08-3.74-.26-5.61-.28,2-1.22,3.9-2.52,6-3.55a25.6,25.6,0,0,1,3.11-1.31c1.66-.54,7.34-.72,4.69,3.3C218.19,405,213.68,404.71,211.45,404.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6,398.88c2.63,2.85,6.4,4.47,9.71,6.36a.53.53,0,0,0,.76-.42c.07,0,.14,0,.13-.13a23.07,23.07,0,0,0-4.95-10.89c-1.53-1.8-4.48-3.36-6.55-1.33S194.06,397.21,195.6,398.88Zm-.51-3.62c0-4.82,4.65-1.51,5.73-.15a24.14,24.14,0,0,1,1.85,2.83c1.18,2,2.06,4.17,3,6.29-1.57-1-3.21-1.92-4.82-2.89C199,400.18,195.07,397.91,195.09,395.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.13,318.08c-.06,5.14-5.2,14.52-12.24,25-13.54,20.19-34.15,44.44-39.24,50.36l-1.16,1.34-36.42-28,.42-.54,32.07-42-95.68-.56,36.33-28.25s2.95,1.7,9.07.8c21.12-3.09,68.73-9.93,79.95-9.48C257.71,287.37,270.35,301.54,270.13,318.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.89,343.09c-13.54,20.19-34.15,44.44-39.24,50.36l-37.16-27.19,32.07-42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,308.65a42.66,42.66,0,0,0-3.31,4.24l-3.41,4.44,0,.05c.2-.44.4-.88.61-1.31.71-1.48,1.28-3,2.13-4.42.05-.09-.08-.17-.13-.08-.87,1.4-1.88,2.74-2.62,4.22-.35.69-.68,1.4-1,2.11-.17.39-.35.79-.5,1.18-.07.19-.15.38-.21.58-.5.69-1,1.38-1.49,2.09-1.08,1.56-2,3.21-3.13,4.77-.06.08.08.16.14.08,1.1-1.46,2.34-2.82,3.47-4.27s2.23-3,3.3-4.52,2.07-3,3.12-4.48a45.78,45.78,0,0,0,3.15-4.61A.06.06,0,0,0,225.08,308.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,255.42c6.78,8.35,31.4,32.22,46.77,35.72,8.47,1.93,49.4,7.66,55,2.55,6.58-6,3.53-28.51-1.7-28.72-15.94-.63-45.44,2.49-52.81.87-3.34-.74-21-12.14-39.88-21.25C131.3,241.14,126.43,249.74,131,255.42Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.79,263s-.09.87-.24,2.35c0,.24,0,.5-.07.77-.09.85-.19,1.85-.3,2.95,0,.13,0,.26,0,.39q-.13,1.38-.3,2.94c0,.25-.06.51-.08.77-.1.95-.21,1.94-.31,2.95,0,.13,0,.26,0,.39-.11,1-.21,2-.32,3,0,.25-.06.51-.08.76-.11,1-.22,2-.33,2.95,0,.13,0,.26-.05.39-.11,1-.22,2-.33,2.95l-.09.76c-.08.63-.15,1.25-.22,1.85-.05.37-.1.74-.14,1.1,0,.13,0,.26,0,.39q-.11.84-.21,1.62c-.06.46-.12.91-.17,1.33,0,.26-.08.52-.12.76-.2,1.37-.37,2.4-.52,3a1.43,1.43,0,0,1-.13.39s-.05.06-.07.06l-.51-.06-1.42-.15-.77-.08-1.64-.16-1.3-.13-.4,0-2.94-.3-.77-.08-2.94-.3-.4,0-2.94-.31-.77-.08-2.94-.32-.4,0-2.94-.32-.77-.09-2.94-.34-.4,0-2.94-.35-.77-.09-.63-.08-2.31-.29-.4-.05-2.94-.39-.19,0-.58-.08-2.94-.42-.4-.06q-1.59-.24-2.94-.48l-.77-.14c-1.16-.21-2.16-.41-2.94-.61l-.4-.1-.21-.06a12.39,12.39,0,0,1-2.36-1l-.37-.19-.36-.2-.41-.23c-.91-.54-1.89-1.17-2.94-1.9-.13-.08-.26-.18-.4-.28l-.76-.54-1.05-.76-1.13-.85-.77-.59-1.9-1.51-.49-.39-.55-.45-.4-.33-.53-.43c-.68-.57-1.38-1.14-2.07-1.74a4.38,4.38,0,0,1-.34-.29l-.56-.47-.21-.18c-1-.84-2-1.69-2.94-2.56l-.24-.21-.16-.14-.28-.25-2.66-2.39-.62-.56-.15-.14-.7-.63c-.76-.69-1.51-1.39-2.25-2.08L144,270l-.54-.5-.42-.39-2-1.87-.77-.73-.37-.35-.81-.77-1.77-1.7-.39-.38-.88-.86-.41-.4L134,260.39l-.76-.76-.55-.54-.64-.65-.11-.12a16.41,16.41,0,0,1-1.65-1.95c-.14-.18-.27-.37-.39-.56s-.19-.29-.28-.43a3.26,3.26,0,0,1-.24-.4,13.64,13.64,0,0,1-1.33-2.94,7.49,7.49,0,0,1-.23-.77,9.85,9.85,0,0,1-.32-2.94c0-.14,0-.27,0-.4a5.79,5.79,0,0,1,1.09-2.94,4.89,4.89,0,0,1,.74-.77,4.26,4.26,0,0,1,.53-.39,3.64,3.64,0,0,1,.39-.23,6.79,6.79,0,0,1,2.95-.71H134a14.1,14.1,0,0,1,2.48.34h0l.47.12a2.79,2.79,0,0,1,.39.1,22.94,22.94,0,0,1,2.31.76l.64.26.77.33.38.18c.51.23,1,.49,1.58.78l1,.51.39.21,2.69,1.44.26.14.48.26a2.69,2.69,0,0,1,.29.16c1,.53,2,1.07,2.94,1.61l.4.22,1.7,1,1.24.7.13.07.64.36,2.94,1.67.4.23,1.19.68.7.4,1,.6.77.45,2.94,1.68.36.21,0,0,1.3.75,1.64.92.77.44,2.86,1.58.08,0,.4.21.28.15c1,.51,1.85,1,2.66,1.37l.77.36a19.62,19.62,0,0,0,2.94,1.17l.15,0,.25.06a3.67,3.67,0,0,0,.42.07,23.91,23.91,0,0,0,2.52.05l.77,0c.86,0,1.85,0,2.94-.09l.4,0,1.19-.05,1.75-.08.77,0,2.94-.16.4,0,2.94-.17.77,0,2.94-.18.4,0,2.94-.18.77-.05,2.94-.19.4,0,2.94-.2.77-.05,2.94-.2.4,0,2.94-.2.77-.06,2.94-.21.4,0Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.33,243.6v12.77c-.14-.18-.27-.37-.39-.56v-12A3.64,3.64,0,0,1,130.33,243.6Zm6.66-.24v19.93l.39.38V243.46A2.79,2.79,0,0,0,137,243.36Zm-3.71-.47v16.74l.76.76v-17.5Zm7.05,1.59v22l.77.73V244.81Zm3.71,1.8V270l.39.36V246.49Zm7.05,3.82v26.29l.16.14.24.21V250.32Zm-3.23-1.77-.48-.26v25.12h.15l.62.56V248.49A2.69,2.69,0,0,0,147.86,248.33Zm6.7,3.71-.13-.07V279.3l.21.18.56.47V252.4Zm3.58,2v28.34l.4.33V254.3Zm7.41,4.25-.36-.21v29.72c.14.1.27.2.4.28V258.32ZM161.48,256v29.11l.77.59V256.43Zm7.05,4v30.23h.41l.36.2v-30Zm3.71,2.06v29.62l.4.1V262.28Zm7.2,3.3-.15,0V293l.4.06V265.37Zm-3.86-1.57v28.6l.77.14V264.16Zm7,1.75v28h.58l.19,0V265.53Zm3.71-.11V294l.4.05V265.42Zm7-.35v29.77l.4,0V265.07Zm-3.71.2v29.13l.77.09V265.25Zm7-.39v30.34l.77.09V264.86Zm3.71-.22v31l.4,0v-31Zm7.05-.45V296.4l.4,0V264.2Zm-3.71.24V296l.77.08V264.42Zm7.05-.47v32.74l.77.08V264Zm3.71-.25v33.37l.4,0V263.72Zm7.05-.5v29q.1-.78.21-1.62c0-.13,0-.26,0-.39,0-.36.09-.73.14-1.1V263.22Zm-3.71.27v33.93l.77.08V263.46Zm-1.64,33.77,1.64.16.77.08,1.42.15h.58a1.43,1.43,0,0,0,.13-.39Zm-33-3.71.19,0,2.94.39.4.05,2.31.29H221.3c0-.24.07-.5.12-.76Zm-14.27-3.34.36.2.37.19H221.8c0-.13,0-.26,0-.39Zm-9.85-7.05.49.39h63c0-.13,0-.26.05-.39Zm4.29,3.34,1.05.76h57.78l.09-.76Zm-8.74-7,.56.47a4.38,4.38,0,0,0,.34.29H223c0-.25.05-.51.08-.76Zm-3.83-3.34.28.25.16.14h72.16c0-.13,0-.26,0-.39Zm-7.73-7.05.42.39h80.64c0-.13,0-.26,0-.39Zm3.6,3.33.7.63v.14h76.38c0-.26.05-.52.08-.77Zm41.25-7.05-1.19.05-.4,0c-1.09,0-2.08.08-2.94.09l-.77,0a23.91,23.91,0,0,1-2.52-.05,3.67,3.67,0,0,1-.42-.07v-.06H139.15l.81.77h84.52c0-.27.05-.53.07-.77Zm-15.29-3.09-.4-.21v0H135.7l.41.4h36.81ZM159.73,255H129.42a3.26,3.26,0,0,0,.24.4h30.77Zm5.86,3.36v0H132l.11.12.64.65h34.16ZM154.43,252l-1.24-.7H127.86a7.49,7.49,0,0,0,.23.77h26.47Zm-7.05-3.9-.26-.14H127.58c0,.13,0,.26,0,.4h20.32Zm-6.28-3.26-.77-.33-.64-.26H129.41a4.89,4.89,0,0,0-.74.77h12.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,282c-9.53-7.88-20.45-18.42-25.52-23.54-7-7.05-6.27-17.61,4.43-15.21h0C139.43,248.07,152.12,271.73,157.61,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.2,266.08c0-.09-.13-.12-.15,0-.46,2.32-.65,4.7-.91,7.05s-.51,4.85-.73,7.29c-.43,4.84-.94,9.72-1.1,14.59a.16.16,0,0,0,.31,0c.73-4.78,1.12-9.64,1.57-14.45.22-2.38.44-4.77.61-7.16S218.23,268.51,218.2,266.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,317.64a4.88,4.88,0,0,1-1.59.51l-.4.08-1,.21-1.9.34-.31.05-.46.07-2.94.47-.4.05c-.93.15-1.91.29-2.94.44l-.77.11-2.94.41-.4.05-2.94.4-.77.1-2.94.38-.4.05-1.19.15-1.75.23-.34,0c-.14,0-.29,0-.43.06l-2.94.36-.4.05-2.49.3-.45.05-.77.1-2.94.36-.4.05-2.94.34-.77.09-2.94.34-.4.05-2.94.34c-.26,0-.52.05-.77.09l-2.94.32-.4.05-.5,0-2.44.26-.77.09-2.94.3-.4.05h-.14c-1.09.11-2,.2-2.8.26l-.77.07-.84.06a3.08,3.08,0,0,1-.68,0,.71.71,0,0,1-.06-.39c0-.52,0-1.53.14-2.94,0-.24,0-.5.06-.77.08-.87.18-1.85.3-2.95,0-.13,0-.26,0-.39.1-.92.21-1.9.33-2.95l.09-.76c.11-.94.23-1.93.36-3,0-.13,0-.26,0-.39q.11-.78.21-1.59l.18-1.36c0-.25.07-.5.1-.76.13-1,.27-1.94.41-2.95l.06-.39a1.11,1.11,0,0,1,0-.17c.13-.91.26-1.84.4-2.78,0-.25.07-.5.11-.76.15-1,.3-1.95.45-2.95l.06-.39c.15-1,.3-2,.46-3,0-.25.09-.5.13-.76.15-1,.32-2,.48-2.95,0-.13,0-.26.06-.39.17-1,.34-2,.52-2.95,0-.25.08-.51.13-.76s.09-.54.14-.8l.39-2.15s0-.05,0-.07l.06-.32c.18-1,.37-2,.56-2.95,0-.25.09-.51.15-.76.18-1,.38-2,.57-3l.09-.39c.2-1,.4-2,.61-2.95.06-.26.11-.51.16-.77.22-1,.44-2,.67-2.94,0-.11,0-.21.07-.32s0-.05,0-.07c.23-1,.47-2,.7-2.95l.06-.23c0-.18.09-.36.14-.54.25-1,.5-2,.76-2.94,0-.13.07-.27.11-.4.27-1,.55-2,.83-2.94l.24-.77c.28-.93.57-1.82.86-2.66,0-.09.06-.19.1-.28s.09-.27.14-.4.1-.3.16-.44c.17-.49.35-1,.53-1.41s.29-.74.44-1.09.23-.52.34-.77a19,19,0,0,1,1.61-2.94s0,0,0,0,.18-.26.27-.37a7.71,7.71,0,0,1,.5-.59l.28-.28.53-.48c.68-.6,1.31-1.13,1.9-1.59a1.81,1.81,0,0,1,.23-.18l.4-.31.38-.28c.92-.68,1.76-1.23,2.56-1.73L120,242l.16-.1a6.61,6.61,0,0,1,1.36-.62,12.69,12.69,0,0,1,1.42-.38l.11,0,.29-.06a28.07,28.07,0,0,1,2.94-.37l.77,0c1,0,2-.07,2.94,0h.4c1.09,0,2.1.09,2.94.18l.77.09a9.06,9.06,0,0,1,1.37.25l.17.06a2.2,2.2,0,0,1,.54.34,8,8,0,0,1,.86.83l.4.45c.39.47.83,1,1.27,1.66.18.25.36.5.54.77.37.55.75,1.15,1.13,1.78.23.37.47.76.69,1.16l.08.13.15.27c.53.94,1,1.93,1.52,2.94.13.25.25.51.37.77q.48,1.05.9,2.13c.11.27.21.54.31.81l.09.24.06.16a29.52,29.52,0,0,1,.86,2.84.3.3,0,0,1,0,.1c.06.22.12.48.2.77.19.77.44,1.76.75,2.94,0,.13.07.26.11.4.23.89.48,1.87.77,2.94,0,.22.11.45.17.68a.29.29,0,0,1,0,.09q.36,1.33.75,2.82l0,.13c0,.13.07.26.1.39l.78,2.94c.06.25.13.51.2.77.25,1,.51,1.94.77,2.95,0,.13.07.26.11.39.25,1,.51,2,.77,3l.18.69a.64.64,0,0,1,0,.07c.13.47.25.95.38,1.43l.39,1.52c0,.13.07.26.11.39.25,1,.51,2,.76,2.95.07.25.14.5.2.76.26,1,.52,2,.77,2.95,0,.13.07.26.1.39.2.78.41,1.56.61,2.34l.15.61c.07.25.13.51.2.76l.42,1.63c.11.45.22.89.34,1.32,0,.13.06.26.1.39l.74,2.95c.07.26.13.51.2.76.25,1,.5,2,.73,2.95,0,.13.07.26.1.39l.72,2.95h0v0l.18.74c.07.33.15.65.22,1,.17.69.33,1.36.47,2l.09.39c.26,1.13.47,2.12.64,3,.06.27.11.53.15.76A6,6,0,0,1,160.13,317.64Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,283.51v41.92l-.4.05V285.73l.39-2.15S102.14,283.53,102.14,283.51Zm-3.36,20.83-.06.39c-.14,1-.28,2-.41,2.95,0,.26-.07.51-.1.76L98,309.8v16l.77-.07V304.17A1.11,1.11,0,0,0,98.78,304.34Zm7-38.2c-.23,1-.47,1.95-.7,2.95h0v56l.77-.09V265.91ZM109,255c0,.13-.1.26-.14.4s-.07.19-.1.28v69.07l.4-.05V254.54C109.13,254.68,109.08,254.83,109,255Zm6.81-10.17v79.12l.4-.05V244.5Zm-3.44,3.12c-.09.11-.18.24-.27.37v76.06c.25,0,.51-.06.77-.09V247.34A7.71,7.71,0,0,0,112.4,247.93Zm6.78-5.44v81.05l.77-.09V242Zm3.82-1.61h-.11v82.23l.4-.05V240.82Zm6.94-.52v81.89l.4-.05V240.36Zm-3.71.09V322.7l.77-.1V240.41Zm7,.09v81.3c.14,0,.29,0,.43-.06l.34,0V240.63Zm3.71,1.57v79.25l.4-.05V242.56ZM144.35,255c-.1-.27-.2-.54-.31-.81v66.26l.4-.05V255Zm-3.33-7c-.22-.4-.46-.79-.69-1.16v74.16l.77-.1V248.06Zm6.38,18.21a.29.29,0,0,0,0-.09V320l.77-.11V269Q147.76,267.48,147.4,266.14Zm3.71,14.1a.64.64,0,0,0,0-.07v39.25l.4-.05v-37.7C151.36,281.19,151.24,280.71,151.11,280.24Zm7.21,28.2-.18-.74v10.53l.4-.08v-8.74C158.47,309.09,158.39,308.77,158.32,308.44Zm-3.54-14.1c-.07-.25-.13-.51-.2-.76l-.15-.61V318.9l.46-.07.31-.05V296ZM96.45,325.49a.71.71,0,0,0,.06.39H98v-.06l.77-.07c.77-.06,1.71-.15,2.8-.26Zm.2-3.71c0,.27,0,.53-.06.77h30.86l2.49-.3.4-.05,2.94-.36c.14,0,.29,0,.43-.06Zm.34-3.34c0,.13,0,.26,0,.39h57.94l.31-.05,1.9-.34Zm62-7.05H97.82c0,.13,0,.26,0,.39H159.1Zm.73,3.34H97.41l-.09.76h62.57C159.85,315.26,159.8,315,159.74,314.73Zm-1.6-7v0H98.31c0,.26-.07.51-.1.76h60.11Zm-.83-3.36H98.78l-.06.39h58.69C157.38,304.6,157.34,304.47,157.31,304.34Zm-1.77-7H99.82l-.06.39h55.88C155.6,297.55,155.57,297.42,155.54,297.29Zm.84,3.34H99.31c0,.26-.07.51-.11.76h57.38C156.51,301.14,156.45,300.89,156.38,300.63Zm-1.8-7.05H100.41c0,.26-.09.51-.13.76h54.5C154.71,294.09,154.65,293.83,154.58,293.58Zm-.86-3.34H101c0,.13,0,.26-.06.39h52.93C153.79,290.5,153.75,290.37,153.72,290.24Zm-1.84-7.05H102.2l-.06.32s0,.05,0,.07H152C152,283.45,151.92,283.32,151.88,283.19Zm.87,3.34H101.6c0,.25-.09.51-.13.76H153C152.89,287,152.82,286.78,152.75,286.53Zm-1.66-6.36-.18-.69h-48c-.06.25-.11.51-.15.76h48.35A.64.64,0,0,0,151.09,280.17Zm-1.06-4H103.57l-.09.39h46.66C150.1,276.4,150.07,276.27,150,276.14Zm-1.85-7.05h-43.1v.07c0,.11,0,.21-.07.32h43.27C148.25,269.35,148.21,269.22,148.18,269.09Zm.88,3.33H104.34c0,.26-.1.51-.16.77h45.08C149.19,272.93,149.12,272.67,149.06,272.42Zm-1.68-6.37c-.06-.23-.12-.46-.17-.68H106c0,.18-.1.36-.14.54l-.06.23H147.4A.29.29,0,0,0,147.38,266.05Zm-1-4H106.86c0,.13-.08.27-.11.4h39.69C146.4,262.29,146.36,262.16,146.33,262Zm-1.89-6.81V255H109c0,.13-.1.26-.14.4H144.5Zm.94,3.1H107.93l-.24.77h37.89C145.5,258.8,145.44,258.54,145.38,258.32Zm-2.61-7H110.5c-.11.25-.23.5-.34.77h33C143,251.78,142.9,251.52,142.77,251.27Zm-1.67-3.21-.08-.13H112.4c-.09.11-.18.24-.27.37s0,0,0,0h29.14Zm-5.51-7.12-.17-.06H122.89v0a12.69,12.69,0,0,0-1.42.38h14.66A2.2,2.2,0,0,0,135.59,240.94Zm3.07,3.28h-22l-.38.28-.4.31a1.81,1.81,0,0,0-.23.18H139.2C139,244.72,138.84,244.47,138.66,244.22Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,321.51c-9.43,1.21-19.8,2.43-27.51,3.27l1.43-71.65c1.12-2.88,2.29-5,3.46-6.07l.53-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8,311.53q-.72-3.33-1.45-6.66-1.47-6.66-3-13.31-3.09-13.41-6.55-26.73c-1.28-5-2.65-9.94-3.91-14.93a.08.08,0,0,0-.15,0c2.31,8.84,4.32,17.76,6.39,26.66s4.1,17.72,6.08,26.6l1.65,7.47c.55,2.52,1,5.12,1.72,7.58.08.28.57.22.53-.08C149.85,316,149.27,313.73,148.8,311.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,252.19c-3.7.51-9.4-5.62-11.43-10.34-.14-.32.64-3.52,1.41-7.45.45-2.39.9-5.06,1.14-7.52,0-.51,1.68.58,1.68.58l3.11,1.08,10.31,3.56a39.38,39.38,0,0,0-2.39,9.32,5,5,0,0,0,0,1v.17C137.81,244.57,137.42,251.69,133.84,252.19Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.68,242.45v.17a9.77,9.77,0,0,1-1.59-.07C125.7,241.33,125.65,228,125.65,228l4.1.57,10.31,3.56a39.38,39.38,0,0,0-2.39,9.32A5,5,0,0,0,137.68,242.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,207.26c-2.77,5-3.18,21.21-.08,25.48,4.51,6.2,13.5,8.58,19.18,2.8,5.5-5.61,5.66-26.69,2-30.74C142.65,198.83,130.94,199.8,126.84,207.26Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25,220.66s-.09.05-.09.09c0,1.09-.18,2.34-1.18,2.67,0,0,0,.07,0,.06C140.2,223.35,140.42,221.69,140.25,220.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,219.49c-1.75-.18-2,3.32-.37,3.5S140.77,219.65,139.31,219.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52,221.27s.09.06.08.11c-.11,1.08,0,2.34.91,2.77,0,0,0,.07,0,.06C146.3,224,146.25,222.28,146.52,221.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,220.21c1.76,0,1.65,3.5,0,3.51S146.1,220.22,147.57,220.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,217.79a13.62,13.62,0,0,0,1.39-.38,2.31,2.31,0,0,0,1.34-.66.75.75,0,0,0-.05-.91,1.85,1.85,0,0,0-1.84-.32,2.7,2.7,0,0,0-1.64,1.06A.79.79,0,0,0,138,217.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,218.54c-.48-.12-.9-.3-1.37-.46a2.34,2.34,0,0,1-1.3-.74.74.74,0,0,1,.1-.9,1.87,1.87,0,0,1,1.86-.22,2.74,2.74,0,0,1,1.58,1.15A.8.8,0,0,1,149.05,218.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,230.28c.24.27.48.64.87.7a2.86,2.86,0,0,0,1.19-.19,0,0,0,0,1,0,.06,1.48,1.48,0,0,1-1.42.49,1.16,1.16,0,0,1-.79-1C138.86,230.25,139,230.24,139,230.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,227.5a3.71,3.71,0,0,0,2.35,1.82,4.57,4.57,0,0,0,1.33.15,1.11,1.11,0,0,0,.26,0l.24,0a.27.27,0,0,0,.23-.23h0a.41.41,0,0,0,0-.11h0V229c.08-.84.08-2.11.08-2.11.3.17,1.81,1,1.81.54a55.7,55.7,0,0,0-.65-11.3.1.1,0,0,0-.2,0c-.18,3.49.27,7,.15,10.5a6.52,6.52,0,0,0-1.71-.66c-.12,0,0,2.47,0,2.85v0a5.15,5.15,0,0,1-3.74-1.46C139.94,227.34,139.85,227.41,139.91,227.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,210.27c-5.57,3.17-12.31-2.89-12.31-2.89a5.75,5.75,0,0,1-6.11,3.14s-1.78,8.82-4.13,8.61c-3.58-.32-3.67-12.57-2.34-14.86s4.42-2.65,4.42-2.65a5.9,5.9,0,0,1,2.73-3.34c2.6-1.67,10.82,1.56,10.82,1.56a7.9,7.9,0,0,1,2.41-2.74,2.22,2.22,0,0,1,3.16.56,5.25,5.25,0,0,0-1,2.13c-.64,2.57,1.49,2.74,1.67.38a3.76,3.76,0,0,0-.63-2.51c1.18-1.46,2.94-1.82,3.91-.9C153.05,198.42,153.35,207.64,148.72,210.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.51,220.64s-2.58-5.72-5.11-4.89-1.25,8.65,1.25,10.16a2.79,2.79,0,0,0,3.95-.78Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.82,218s-.06.05,0,.07c1.75,1.12,2.41,3.06,2.77,5a1.54,1.54,0,0,0-2.19-.84c-.05,0,0,.11,0,.11a1.72,1.72,0,0,1,1.75.94,8.64,8.64,0,0,1,.6,1.66c.06.19.38.16.35-.05v0C126.6,222.43,125.36,218.71,122.82,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.68,242.62,134.32,251l-11.61-11.16-3.09,3.77s11.56,17.94,11.61,17.12l3.51-7.94,5.56,5.29-.83-13.66Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.27,251.29c-.21-2.25-.36-4.53-.68-6.77a.08.08,0,0,0-.15,0c-.39,2.19.47,10.79.52,12.86l0,0c-.24-.23-5.15-4.65-5.2-4.58-.77,1.27-3.35,7-3.53,7.57-1.83-2.85-9.57-14.07-11.71-16.75a.08.08,0,0,0-.13.08c1.63,3,11.63,17.83,11.77,17.79a86.89,86.89,0,0,0,3.67-8.39c.84,1,5.82,6,5.83,5.63A70.57,70.57,0,0,0,140.27,251.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.41 303.24 224.02 303.24 231.69 245.77 191.09 245.77 183.41 303.24",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.41 303.24 226.01 303.24 233.69 245.77 193.08 245.77 185.41 303.24",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,271.66a4.4,4.4,0,0,1-4.3,3.95,3.56,3.56,0,0,1-3.6-3.95,4.39,4.39,0,0,1,4.29-4A3.57,3.57,0,0,1,213.5,271.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.35,258.62c-1.91,26.75,2.8,45.17,7.51,47.14,12.7,5.32,51.31,8.28,60.16,7.34,3.46-.36,1.18-29.05-2.54-29-9.22.25-43,.53-43.44.33-2.87-1.35-3-10.27-9.64-29.33C117.05,239.72,111.13,247.68,110.35,258.62Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,278.42a4.15,4.15,0,0,1,0,4.73,6.12,6.12,0,0,1,3.16,2.73c1.13,2.27-1.92,5-1.92,5a7.61,7.61,0,0,1,2.87,3.42c.87,2.28-1.82,5.51-1.82,5.51a6.68,6.68,0,0,1,.64,4.59c-.69,2.66-7.32,6.05-11.27,7.31s-16.32,1.15-18.69,1.36l-8.31-25.26s16.08-10.69,20.93-11.52C194.73,275.63,203.09,275.84,205,278.42Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.74,282.8c-4.52-.31-8.88.74-13.3,1.55-.1,0-.07.17,0,.15,4.38-.85,8.88-.82,13.29-1.49A.11.11,0,0,0,204.74,282.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1,290.61a11.71,11.71,0,0,0-3,.49c-1.07.25-2.13.52-3.19.8-2.11.57-4.22,1.19-6.3,1.87a.08.08,0,1,0,0,.15c2.11-.56,4.23-1.1,6.36-1.57,1.07-.24,2.14-.46,3.21-.68a14,14,0,0,0,3-.77A.15.15,0,0,0,206.1,290.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,299.86a8.1,8.1,0,0,0-2.72.59l-2.88.82c-1.93.54-3.85,1.07-5.79,1.54-.1,0-.07.18,0,.15,2-.46,4-.9,5.92-1.39,1-.23,1.94-.48,2.91-.73a7.57,7.57,0,0,0,2.56-.89S207.3,299.86,207.25,299.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.86,282.74v32.2l-2.56-.13c-.24,0-.5,0-.77,0l-.86,0-2.08-.11c-.13,0-.26,0-.4,0l-2.94-.19-.77,0-2.94-.2-.4,0-2.94-.23-.77-.06-2.94-.25-.4,0-2.94-.27-.77-.08-2.94-.31-.4,0c-1-.1-2-.22-2.94-.33l-.77-.09-2.94-.38L137,312l-1.43-.2-1.51-.22-.77-.12-.28-.05c-.91-.14-1.79-.29-2.66-.45l-.4-.07c-1-.18-2-.37-2.94-.57l-.77-.17c-1-.23-2-.46-2.94-.71l-.4-.11q-1.53-.42-2.79-.87l-.15-.05-.77-.3c-.32-.14-.63-.27-.91-.41a8.68,8.68,0,0,1-2-1.25l-.1-.09-.3-.31a8.19,8.19,0,0,1-1-1.3c-.08-.12-.15-.25-.23-.39a19.44,19.44,0,0,1-1.36-2.95l-.27-.76-.09-.28c-.27-.8-.53-1.66-.77-2.57l0-.1-.09-.39c-.25-.94-.47-1.93-.69-3,0-.25-.1-.5-.14-.76-.2-.95-.37-1.94-.53-2.95,0-.13-.05-.26-.07-.39-.15-1-.29-1.95-.42-2.95,0-.25-.07-.51-.1-.76-.12-1-.24-2-.34-2.95,0-.13,0-.26,0-.39-.1-1-.19-2-.27-2.95l-.06-.76c-.06-.76-.11-1.52-.16-2.28,0-.22,0-.44,0-.67l0-.39c-.06-1-.1-2-.14-2.95,0-.26,0-.52,0-.77,0-1-.06-2-.08-2.94v-.39c0-1,0-2,0-2.95v-.77c0-1,0-2,.06-2.94,0-.14,0-.27,0-.4,0-1,.07-2,.13-2.94,0-.26,0-.52,0-.77,0-.48.07-.93.11-1.37s.11-1.08.17-1.57c0-.14,0-.27,0-.4.09-.69.2-1.31.31-1.85.08-.38.16-.74.26-1.09s.15-.52.23-.77a11.65,11.65,0,0,1,1.37-2.94l.3-.4.25-.3a4.78,4.78,0,0,1,.77-.73,3.79,3.79,0,0,1,2.94-.86l.4.08a6.31,6.31,0,0,1,2.92,1.81l0,0c.12.12.24.24.36.38s.28.31.41.48a16.66,16.66,0,0,1,1.64,2.46l.42.77c.3.59.59,1.22.88,1.9.13.32.27.65.4,1,0,0,0,0,0,0l.15.4c.29.79.58,1.63.85,2.52,0,.14.09.28.13.42s.15.51.24.77l.89,2.94.12.4c.18.61.36,1.21.54,1.79.12.39.24.77.35,1.15s.16.52.23.77.13.4.19.6l.72,2.35c0,.13.09.26.13.39.31,1,.62,2,.91,2.94.09.26.17.52.24.77.33,1,.64,2,.94,2.89,0,0,0,0,0,.06s.08.26.13.39l.25.74c.27.81.53,1.54.77,2.21l.29.76a18.1,18.1,0,0,0,1.33,2.95,2.4,2.4,0,0,0,.31.39.42.42,0,0,0,.24.11h.77l2.94-.06h.4l1.3,0,1.64,0,.77,0,2.94-.07h.4l2.94-.07.77,0,2.94-.07h.4l2.94-.07h.77l2.94-.08h.4l2.94-.08.77,0,2.94-.07h.4l2.94-.08.77,0Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.19,257V277.2c0-.22,0-.44,0-.67l0-.39c-.06-1-.1-2-.14-2.95,0-.26,0-.52,0-.77,0-1-.06-2-.08-2.94v-.39c0-1,0-2,0-2.95v-.77c0-1,0-2,.06-2.94,0-.14,0-.27,0-.4,0-1,.07-2,.13-2.94,0-.26,0-.52,0-.77C109.11,257.84,109.15,257.39,109.19,257ZM115.84,246v60l.3.31.1.09V246.12Zm-3.71,1.59v50.15c.24.91.5,1.77.77,2.57V246.9A4.78,4.78,0,0,0,112.13,247.63Zm7.41.7c-.12-.14-.24-.26-.36-.38v60.14l.77.3V248.81C119.82,248.64,119.68,248.48,119.54,248.33Zm3.35,5.61v55.37l.4.11V254.93C123.16,254.59,123,254.26,122.89,253.94Zm7.2,22.59c-.05-.13-.09-.26-.13-.39s0,0,0-.06v34.79l.4.07V277.27Zm-3.28-10.39c-.07-.25-.15-.51-.23-.77s-.23-.76-.35-1.15v45.91l.77.17V266.14Zm6.47,17.55v27.75l.77.12V283.68Zm3.71-.11V312l.4.06V283.58Zm7-.13v29.39l.4,0V283.44Zm-3.71.09v28.88l.77.09v-29Zm7-.17v29.82l.77.08V283.35Zm3.71-.09v30.26l.4,0V283.27Zm7-.18v31l.4,0V283.09Zm-3.33.09h-.38v30.64l.77.06V283.18Zm6.67-.18v31.34l.77,0V283Zm3.71-.09v31.67c.14,0,.27,0,.4,0V282.91Zm3.34-.09v31.94c.27,0,.53,0,.77,0v-32ZM133,311.39l.28.05.77.12,1.51.22h36.3v-.39Zm34.67,3.34.86,0c.27,0,.53,0,.77,0l2.56.13v-.21Zm-49.4-7.05c.28.14.59.27.91.41l.77.3.15.05h51.76v-.76Zm-3.65-3.34c.08.14.15.27.23.39h57v-.39Zm-2.61-7,.09.39h59.76v-.39Zm1,3.34.27.76h58.6v-.76Zm-1.81-7.05c0,.26.09.51.14.76h60.54v-.76Zm-.6-3.34c0,.13,0,.26.07.39h61.21v-.39Zm-.9-7.05c0,.13,0,.26,0,.39H133a2.4,2.4,0,0,1-.31-.39Zm44.75,0h0l-2.94.07h-.4l-2.94.07-.77,0-2.94.07H144l-2.94.07-.77,0-1.64,0h33.17v-.39Zm-44.37,3.34c0,.25.06.51.1.76h61.7v-.76Zm21.05-7H109.35l.06.76h22ZM130,276.14H109.12l0,.39h20.94C130,276.4,130,276.27,130,276.14Zm-2.24-7.05H108.86v.39h19C127.81,269.35,127.77,269.22,127.72,269.09Zm1,3.33H108.94c0,.25,0,.51,0,.77h20C128.93,272.94,128.85,272.68,128.76,272.42Zm-2.18-7.05H108.83v.77h18C126.74,265.89,126.66,265.63,126.58,265.37Zm-1-3.34H108.9c0,.13,0,.26,0,.4h16.8Zm-2.26-7h-13.9c0,.13,0,.26,0,.4h14.1Zm1.13,3.34H109.08c0,.25,0,.51,0,.77h15.65C124.59,258.83,124.52,258.58,124.44,258.32Zm-2.85-7H110.21c-.08.25-.16.51-.23.77h12ZM119.18,248v0h-7.3l-.3.4h8C119.42,248.19,119.3,248.07,119.18,248Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.07,282.75a.33.33,0,0,0-.3-.48c-5.06-.06-10.15.21-15.21.34s-10.14.23-15.21.4c-2.85.1-8.33.35-8.38.27s-1.58-4.84-1.91-5.83c-.64-1.93-1.31-3.85-2-5.78-.19-.56-.39-1.12-.59-1.67-.06-.38-.13-.76-.17-1.13s-.12-1-.18-1.56a28.9,28.9,0,0,0-.51-3.07.08.08,0,0,0-.15.05,17.19,17.19,0,0,1,.32,3.2l.06.77c-1-2.66-1.24-3.13-2.09-5.82a.08.08,0,1,0-.15,0c1,3.89,1.54,5.56,2.76,9.4.62,1.94,1.23,3.88,1.88,5.82.32.94,1.78,5.34,2.25,6.22.06.11,5.2-.18,7.73-.22s5.07-.08,7.61-.14l15.21-.38c2.81-.07,5.64-.07,8.45-.23,0,.33.25,2,.23,2.11s.16.13.15,0S172.08,282.78,172.07,282.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.17,285.31c0-.08-.14-.11-.16,0-.32,2.23-.37,4.51-.5,6.76s-.23,4.66-.31,7c-.15,4.65-.38,9.32-.25,14a.15.15,0,0,0,.3,0c.46-4.59.57-9.24.74-13.85q.13-3.42.2-6.86C166.22,290,166.34,287.62,166.17,285.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.11,301.82l0-1c0-.16,0-.33,0-.49a.36.36,0,0,0,0-.22h0c0-.09,0-.18,0-.28a0,0,0,0,0-.08,0c0,.1,0,.19,0,.28h0s0,.06,0,.07c-.09,2.41-.35,4.82-.46,7.23s-.15,4.85-.13,7.29c-2.75-.23-5.54-.2-8.3-.34s-5.72-.35-8.58-.58c-5.73-.46-11.45-1-17.15-1.81l-4.75-.67c-1.61-.23-3.29-.35-4.87-.73-.1,0-.14.14,0,.16,1.45.18,2.89.58,4.33.84s2.82.5,4.24.72q4.24.68,8.51,1.2,8.52,1.06,17.1,1.49l4.91.21c1.61.05,3.24.15,4.85.07A.29.29,0,0,0,172,315c0-2.53.13-5.06.16-7.59,0-1.24,0-2.48,0-3.72C172.14,303.06,172.13,302.44,172.11,301.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,262.31c2.55,3.28,8.45,6.86,9.47,9.77a3.55,3.55,0,0,1-1.12,4.08s3.32.83,3.81,3.62c.25,1.44-1.83,3.11-1.83,3.11a4.22,4.22,0,0,1,2.91,3.29c.22,2-1.89,3.37-1.89,3.37s2.17,1.92,1.74,4c-.86,4.28-17.74,8-21.72,2.36-1.86-2.63,2.31-3.31,2.31-3.31s-6.23-.47-7.09-3.93,4.62-4,4.62-4-6.05-.5-6.57-4.18,5-3.46,5-3.46-4.31-1.71-4.07-4.62c.4-4.8,9.82-.71,13.34-2.41Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,289.81a0,0,0,0,1,0,.09,30,30,0,0,1-17.62,2.8c-.19,0-.22-.36,0-.36A61.29,61.29,0,0,0,242.53,289.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.9,282.9c.06,0,.1.09,0,.12a28.08,28.08,0,0,1-19.41,1.86c-.22-.06-.36-.35-.09-.29C226.88,285.55,236.56,284.57,241.9,282.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.71,276.76c6.35,1.62,12.59,1,18.91-.48.08,0,.1.09,0,.13-2.88,1.59-7,2.13-10.26,2.29a17.21,17.21,0,0,1-8.74-1.72C220.54,276.93,220.57,276.73,220.71,276.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,393.33c-.84,2.26-42,53.43-44.8,54.39-1.06.37-8.86-5.19-18.1-12.18-2-1.51-4-3.08-6.12-4.68-13.47-10.41-27.52-21.77-27.52-21.77l27.43-34.31,26.77,22.72,5.88,5s24.52-12.54,27.71-13.26S350.89,391.06,350.05,393.33Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,393.33c-.84,2.26-42,53.43-44.8,54.39-1.3.44-12.54-7.86-24.22-16.86l26.68-33.36,5.88,5s24.52-12.54,27.71-13.26S350.89,391.06,350.05,393.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,393.33c-.84,2.26-42,53.43-44.8,54.39-1.06.37-8.86-5.19-18.1-12.18l26.44-33.06s24.52-12.54,27.71-13.26S350.89,391.06,350.05,393.33Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.42,392.41c-7.12,8.41-35,43-41.39,51.84,0,.07,0,.11.05,0,7.23-8.17,34.84-43,41.48-51.76C347.7,392.34,347.57,392.24,347.42,392.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.81,391a8.82,8.82,0,0,0-2,6.81,8.57,8.57,0,0,0,3,5.6c.05,0,.13-.05.08-.1a10.23,10.23,0,0,1-1-12.23A.07.07,0,0,0,336.81,391Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.12,399.84c-2.81,3.39-4.8,8.35-3.71,12.74,0,.17.29.11.32,0a60.8,60.8,0,0,1,3.86-12.42A.28.28,0,0,0,317.12,399.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.29,398c-2.81,3.39-4.8,8.35-3.71,12.74,0,.17.28.11.31,0a60.83,60.83,0,0,1,3.87-12.42A.28.28,0,0,0,320.29,398Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.45,396.2c-2.81,3.39-4.8,8.35-3.71,12.74.05.17.29.11.32,0a60.8,60.8,0,0,1,3.86-12.42A.28.28,0,0,0,323.45,396.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,394.38c-2.81,3.4-4.8,8.35-3.71,12.74,0,.17.28.11.31,0a61,61,0,0,1,3.87-12.42A.28.28,0,0,0,326.62,394.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,435.51c-3.09,3.86,2.91,8.67,6,4.8S302.73,431.65,299.64,435.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,388.76c-2.84.58-3.19,3.9-2.56,6.17a23.05,23.05,0,0,0,6.27,10.18.11.11,0,0,0,.18,0,.54.54,0,0,0,.78-.4c.27-3.8,1-7.83.14-11.61C315.23,390.88,313.63,388.21,311,388.76Zm3.9,10.08c-.09,1.87-.27,3.73-.29,5.61a69.82,69.82,0,0,1-3.53-6,24.89,24.89,0,0,1-1.3-3.11c-.54-1.66-.7-7.34,3.31-4.68C315.25,392.1,315,396.61,314.85,398.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,414.67c2.86-2.62,4.49-6.39,6.4-9.69a.53.53,0,0,0-.42-.76.12.12,0,0,0-.14-.13A23,23,0,0,0,304,409c-1.8,1.52-3.37,4.47-1.35,6.54S307.4,416.2,309.07,414.67Zm-3.62.5c-4.82-.05-1.5-4.66-.12-5.73a24.14,24.14,0,0,1,2.83-1.85c2-1.17,4.18-2,6.3-3-1,1.56-1.93,3.2-2.91,4.8C310.39,411.3,308.1,415.19,305.45,415.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.28,392.32l-28.55,38.52L181.39,364l-9.29-6.45s-2.63,1.77-6.59,4c-5.5,3-13.56,6.89-20.69,7.94-12,1.77-31.93,1.58-42-11.9-8.49-11.35-2.69-31.91-2.69-31.91l14-1.55s29-24.23,49.18-25c8.55-.34,21,6.14,32.53,12.91S306.28,392.32,306.28,392.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,357.54s-2.63,1.77-6.59,4c-7-8.38-21.82-23.6-22.27-24.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,317.08c-1.86,1.28-3.65,2.66-5.49,4s-3.66,2.53-5.37,3.95-3.4,3-5,4.55c-.79.75-1.58,1.51-2.34,2.28a22.32,22.32,0,0,0-2.24,2.43c-.06.08.06.18.14.13a28.17,28.17,0,0,0,2.49-2c.87-.73,1.72-1.48,2.59-2.21,1.67-1.42,3.37-2.8,5-4.23s3.19-3,4.83-4.39,3.6-3,5.43-4.42C123.52,317.11,123.49,317.05,123.45,317.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,390.94c-1.86,2-3.57,4.15-5.3,6.26s-3.46,4.25-5.17,6.39c-3.42,4.27-6.88,8.53-10.24,12.85-1.85,2.38-3.67,4.77-5.39,7.24a.11.11,0,0,0,.18.14c3.69-4.05,7-8.37,10.47-12.64s6.84-8.58,10.19-12.91c1.84-2.37,3.74-4.73,5.43-7.21A.11.11,0,0,0,299.58,390.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08,330.79c-3.39-3.93-17.93-14.24-27.22-18.85a.08.08,0,0,0-.07.14c9.26,5.95,24.52,17.23,27.15,18.91C223.06,331.06,223.17,330.89,223.08,330.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "182.9 224.94 185.47 230.14 191.2 230.97 187.05 235.02 188.03 240.73 182.9 238.03 177.78 240.73 178.75 235.02 174.6 230.97 180.34 230.14 182.9 224.94",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.94 208.28 203.79 212.18 207.92 212.8 204.93 215.83 205.64 220.11 201.94 218.09 198.23 220.11 198.94 215.83 195.95 212.8 200.09 212.18 201.94 208.28",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.14 183.96 188.31 186.33 190.92 186.71 189.03 188.55 189.48 191.16 187.14 189.93 184.8 191.16 185.25 188.55 183.36 186.71 185.97 186.33 187.14 183.96",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.94 170.04 202.82 171.84 204.81 172.12 203.37 173.52 203.71 175.5 201.94 174.56 200.16 175.5 200.5 173.52 199.06 172.12 201.05 171.84 201.94 170.04",
    style: {
      fill: "#27D2FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Reviews--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.55,
    y: 195.09,
    width: 150.56,
    height: 60.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.58 255.29 240.58 267.25 251.42 255.29 240.58 255.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.43,
    cy: 226.69,
    r: 23.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.71 206.37 311.42 209.84 315.24 210.39 312.48 213.09 313.13 216.9 309.71 215.1 306.29 216.9 306.94 213.09 304.18 210.39 308 209.84 309.71 206.37",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.77 206.37 326.48 209.84 330.3 210.39 327.53 213.09 328.19 216.9 324.77 215.1 321.35 216.9 322 213.09 319.23 210.39 323.06 209.84 324.77 206.37",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.82 206.37 341.53 209.84 345.36 210.39 342.59 213.09 343.24 216.9 339.82 215.1 336.4 216.9 337.06 213.09 334.29 210.39 338.11 209.84 339.82 206.37",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.88 206.37 356.59 209.84 360.42 210.39 357.65 213.09 358.3 216.9 354.88 215.1 351.46 216.9 352.12 213.09 349.35 210.39 353.17 209.84 354.88 206.37",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.94 206.37 371.65 209.84 375.47 210.39 372.71 213.09 373.36 216.9 369.94 215.1 366.52 216.9 367.17 213.09 364.41 210.39 368.23 209.84 369.94 206.37",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 225.19,
    width: 71.44,
    height: 1.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 229.76,
    width: 63.63,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 234.33,
    width: 52.6,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 238.9,
    width: 57.5,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-12)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.23,198.67c-10.85,4.88-13.19,20.17-12.48,41.93.11,3.31,28.09,9.06,41.63-1.14,2.18-1.65-.92-28.27-6.29-35.93C278.43,194,268.94,195.65,262.23,198.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,198.89c-5.67,2.89-9.32,8.63-11,14.65a92.21,92.21,0,0,0-2.25,13.61,53.52,53.52,0,0,0-.2,13.14.12.12,0,0,0,.24,0,113.07,113.07,0,0,1,2.55-24.52c1.41-6.75,4.88-12.79,10.84-16.44C262.38,199.17,262.18,198.77,261.93,198.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,211a20.12,20.12,0,0,0-13.62-14.11,0,0,0,0,0,0,.08c7.52,2.84,11.74,8.57,13.64,16.17,2.07,8.28,2.91,16.68,3.59,25.15a.15.15,0,0,0,.3,0A103.06,103.06,0,0,0,289.71,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.18,248.75l.09.07c4.91,3.35,14.61,9.23,19.79,7.36a11.66,11.66,0,0,0,6.6-6.85,53.61,53.61,0,0,0-6.41-4.45C266.6,239.79,259.7,242.84,254.18,248.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,245.86c.35,1.13,6.34,8.23,11.58,7.63,1.71-.19,1.05-9.56,1.05-9.56l.11-.7,1.52-9.84L264,226.84l-1.71-.86s-.24,2.72-.5,6.11c0,.16,0,.32,0,.48s0,.38-.05.56c0,.5-.09,1-.12,1.53s-.06.78-.07,1.19,0,.82-.07,1.23A64.1,64.1,0,0,0,261.57,245.86Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,232.09a20,20,0,0,0,12.57,11.14l1.52-9.84L264,226.84l-1.71-.86S262,228.7,261.74,232.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,217c2.74,17.26-7.29,20.85-11,21.44-3.37.53-14.28,1.35-18.79-15.53s2-23,9.64-24.67S285.25,199.76,288,217Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,216a11.7,11.7,0,0,1-1.15.35,1.88,1.88,0,0,1-1.25.14.62.62,0,0,1-.37-.66,1.55,1.55,0,0,1,1.16-1.05,2.24,2.24,0,0,1,1.63,0A.67.67,0,0,1,285,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.3,216.51a11.89,11.89,0,0,0,1.2.12,1.91,1.91,0,0,0,1.25-.1.64.64,0,0,0,.23-.73,1.52,1.52,0,0,0-1.34-.8,2.3,2.3,0,0,0-1.6.32A.67.67,0,0,0,272.3,216.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,220.51s-.09.07-.08.11c.17,1.18.17,2.56-.86,3.07,0,0,0,.08,0,.07C275.44,223.43,275.43,221.6,275.08,220.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.89,219.39c-1.92.07-1.64,3.9.13,3.84S275.49,219.34,273.89,219.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.15,219.65c-.32.24-.62.65-1,.71s-.84-.29-1.18-.66c0,0-.06,0-.06.05,0,.74.38,1.47,1.17,1.52s1.2-.63,1.33-1.39C273.41,219.74,273.28,219.55,273.15,219.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47,219.43s.1,0,.1.1c0,1.19.29,2.55,1.39,2.87,0,0,0,.07,0,.07C282.63,222.37,282.32,220.57,282.47,219.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46,218.12c1.9-.26,2.29,3.56.53,3.8S281.86,218.35,283.46,218.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,218.29c.32.17.66.51,1,.5s.69-.46.91-.89c0,0,.06,0,.07,0,.09.73-.07,1.51-.76,1.72s-1.16-.38-1.41-1.09C284.07,218.44,284.15,218.22,284.28,218.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.32,229.57c.29.27.59.65,1,.67a3,3,0,0,0,1.27-.33,0,0,0,0,1,.05.06,1.58,1.58,0,0,1-1.49.68,1.25,1.25,0,0,1-1-1C276.19,229.56,276.28,229.53,276.32,229.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.92,224.87s.39,1.75.46,2.58a12.93,12.93,0,0,0-5.18.73c-.09,0-.27-.11-.05-.27a7.33,7.33,0,0,1,4.54-1.06c0-.23-.74-2.75-.61-2.77a7.71,7.71,0,0,1,1.93.27c-.71-3.66-2-7.19-2.66-10.85a.11.11,0,0,1,.21-.08A61,61,0,0,1,282.93,225C283,225.47,281.26,225,280.92,224.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19,222.92c1.86-.26,6.33-5.82,5.74-14.89,0,0,0,8.18-.55,9.43s2.49-3.13,2.12-10.45a29.89,29.89,0,0,0,7.81,3.28c3.53.68,5.64.48,5.87.21s-5-1.46-6.49-2.93c0,0,9.53,3.52,13.78,3.5.49,0-.1-9.1-7-12.84s-16.51.7-19.08,3.62c0,0-3.23.73-6.39,5.86S256.17,223.21,258.19,222.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.27,224.37s-4.19-5.16-6.56-3.63,1,9.21,4,10.08a3,3,0,0,0,3.84-1.86Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,222.91a0,0,0,0,0,0,.08c2.09.68,3.29,2.49,4.18,4.39a1.62,1.62,0,0,0-2.46-.27.06.06,0,0,0,.06.1,1.84,1.84,0,0,1,2,.49,9.1,9.1,0,0,1,1.07,1.55c.11.17.43.05.35-.15l0,0C261.81,226.46,259.54,223,256.74,222.91Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 250.55,
    y: 118.2,
    width: 150.56,
    height: 60.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.58 178.39 250.58 190.35 261.42 178.39 250.58 178.39",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.43,
    cy: 149.8,
    r: 23.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.72 130.16 321.43 133.63 325.26 134.19 322.49 136.89 323.14 140.71 319.72 138.9 316.29 140.71 316.95 136.89 314.18 134.19 318.01 133.63 319.72 130.16",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.81 130.16 336.52 133.63 340.35 134.19 337.58 136.89 338.23 140.71 334.81 138.9 331.38 140.71 332.03 136.89 329.26 134.19 333.09 133.63 334.81 130.16",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.89 130.16 351.61 133.63 355.44 134.19 352.67 136.89 353.32 140.71 349.89 138.9 346.47 140.71 347.12 136.89 344.35 134.19 348.18 133.63 349.89 130.16",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.98 130.16 366.69 133.63 370.52 134.19 367.75 136.89 368.41 140.71 364.98 138.9 361.55 140.71 362.21 136.89 359.44 134.19 363.27 133.63 364.98 130.16",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.07 130.16 381.78 133.63 385.61 134.19 382.84 136.89 383.49 140.71 380.07 138.9 376.64 140.71 377.3 136.89 374.52 134.19 378.35 133.63 380.07 130.16",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 148.29,
    width: 71.44,
    height: 1.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 152.86,
    width: 41.77,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 157.44,
    width: 61.67,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 162.01,
    width: 56.35,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-12)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.14,165.33l-2.08,9.39L269.9,165l-3.52,5.19s9.27,12.54,19.14,12.54c5.19,0,6.2-11.89,6.2-11.89Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.76,176c-3.8,1.18-10.86-4.28-13.82-8.89-.2-.32.06-3.82.18-8.09.06-2.59.07-5.48-.11-8.11,0-.54,1.87.32,1.87.32l3.47.59,11.46,2a42,42,0,0,0-.89,10.22,5.18,5.18,0,0,0,.19,1.08,1.68,1.68,0,0,0,0,.18C286.62,167.3,287.45,174.86,283.76,176Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.11,165.15a1.68,1.68,0,0,0,0,.18,10.4,10.4,0,0,1-1.69.21c-11.14.52-13.51-13.53-13.51-13.53l4.41-.12,11.46,2a42.08,42.08,0,0,0-.89,10.23A5.08,5.08,0,0,0,286.11,165.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58,129.94c-2,5.79.34,22.88,4.35,26.83,5.82,5.74,15.7,6.68,20.67-.39,4.81-6.86,1.32-29.07-3.2-32.7C283.75,118.33,271.6,121.39,268.58,129.94Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,141.78c0-.05-.08.06-.07.11.19,1.15.21,2.49-.78,3,0,0,0,.08,0,.07C285.44,144.62,285.39,142.83,285,141.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,140.71c-1.87.11-1.52,3.84.22,3.74S285.4,140.62,283.83,140.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.73,141.33s.1,0,.1.1c.07,1.16.35,2.47,1.44,2.76a0,0,0,0,1,0,.06C292,144.19,291.62,142.44,291.73,141.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,140c1.85-.32,2.35,3.4.64,3.69S291.1,140.29,292.65,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.2,139.15c.49-.18.92-.43,1.39-.65a2.42,2.42,0,0,0,1.3-.93.8.8,0,0,0-.21-.95,2,2,0,0,0-2,0,2.89,2.89,0,0,0-1.54,1.4A.85.85,0,0,0,282.2,139.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.92,138c-.53,0-1-.16-1.52-.24a2.47,2.47,0,0,1-1.51-.55.8.8,0,0,1,0-1,2,2,0,0,1,1.91-.55,2.88,2.88,0,0,1,1.86.93A.84.84,0,0,1,293.92,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,152.61c.3.25.61.59,1,.59a3,3,0,0,0,1.22-.41,0,0,0,0,1,.06.06,1.56,1.56,0,0,1-1.41.76,1.23,1.23,0,0,1-1-.93C284.84,152.61,284.92,152.58,285,152.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.67,149.54c1.18,1,5.13,1,5.14.82l-.32-2.77c.34.14,2.07.73,2,.26a59.82,59.82,0,0,0-2.66-11.77.11.11,0,0,0-.21,0c.43,3.7,1.5,7.31,2,11a7.13,7.13,0,0,0-1.91-.39c-.13.05.46,2.59.45,3a12,12,0,0,1-4.24-.57C285.46,149,285.36,149.28,285.67,149.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.66,143.74c1.46-.37,2.83-5.16,2.88-9.8,0-3,1.23-6.75,4.56-7.87,2.21-.75,6.06,1.07,8.27.53s2.61-1.79,3.91-1.76,2.75,3.24,2.75,3.24-2.32-10.11-15.33-6.86c-13.7,3.43-10.94,15.16-9.62,18.92C269.09,143.05,270.66,143.74,270.66,143.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,143.91s-3.71-5.57-6.23-4.26.18,9.33,3.08,10.48a3,3,0,0,0,4-1.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,142a0,0,0,0,0,0,.08c2,.88,3.07,2.8,3.78,4.79a1.65,1.65,0,0,0-2.45-.51.07.07,0,0,0,.06.11,1.81,1.81,0,0,1,2,.69,7.87,7.87,0,0,1,.93,1.65c.09.18.43.09.36-.12v-.05C271,146,269,142.32,266.22,142Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 260.55,
    y: 41.3,
    width: 150.56,
    height: 60.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.58 101.49 260.58 113.46 271.42 101.49 260.58 101.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.43,
    cy: 72.9,
    r: 23.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.72 54.06 331.43 57.53 335.26 58.09 332.49 60.79 333.14 64.61 329.72 62.81 326.29 64.61 326.95 60.79 324.18 58.09 328.01 57.53 329.72 54.06",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.81 54.06 346.52 57.53 350.35 58.09 347.58 60.79 348.23 64.61 344.81 62.81 341.38 64.61 342.03 60.79 339.26 58.09 343.09 57.53 344.81 54.06",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.89 54.06 361.61 57.53 365.44 58.09 362.67 60.79 363.32 64.61 359.89 62.81 356.47 64.61 357.12 60.79 354.35 58.09 358.18 57.53 359.89 54.06",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.98 54.06 376.69 57.53 380.52 58.09 377.75 60.79 378.41 64.61 374.98 62.81 371.55 64.61 372.21 60.79 369.44 58.09 373.27 57.53 374.98 54.06",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.07 54.06 391.78 57.53 395.61 58.09 392.84 60.79 393.49 64.61 390.07 62.81 386.64 64.61 387.3 60.79 384.52 58.09 388.35 57.53 390.07 54.06",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.18,
    y: 71.4,
    width: 71.44,
    height: 1.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.18,
    y: 75.97,
    width: 53.15,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.18,
    y: 80.54,
    width: 63.63,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.18,
    y: 85.11,
    width: 27.3,
    height: 1.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,90.74h-2c-.2-2.55-1.82-6.45-1.41-4.48a19.3,19.3,0,0,1,.26,4.48H277c-.39-3.84,1.32-10.15,1.32-10.15-2,3.17-2.71,7.67-3,10.15h-3.19a23.75,23.75,0,0,1,.48-6.21A20.42,20.42,0,0,0,271,90.74h-3.64a23.85,23.85,0,0,1,4.23-13.46c2.46-3.67-.58-5.81-.52-13,.06-9.51,6.59-13.16,7.67-14.16,14.77-13.68,28.17-1,29.6,8.05,1.39,8.84-1.15,10,3,18C314.37,82.28,314,90.74,314,90.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,95.71l.09.06c4.91,3.35,14.61,9.23,19.79,7.36a11.65,11.65,0,0,0,6.6-6.84,52.7,52.7,0,0,0-6.41-4.46C286.6,86.75,279.7,89.79,274.18,95.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.57,92.81c.35,1.13,6.34,8.23,11.58,7.63,1.71-.19,1.05-9.56,1.05-9.56l.11-.7,1.52-9.84L284,73.79l-1.71-.85s-.24,2.71-.5,6.1c0,.16,0,.32,0,.49s0,.37-.05.55c0,.5-.09,1-.12,1.53s-.06.78-.07,1.19,0,.82-.07,1.23A64.1,64.1,0,0,0,281.57,92.81Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.74,79a20,20,0,0,0,12.57,11.14l1.52-9.84L284,73.79l-1.71-.85S282,75.65,281.74,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,64c2.74,17.26-7.29,20.85-11,21.44-3.37.53-15,1.92-19.46-15s2.65-23.61,10.31-25.24S305.25,46.71,308,64Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,71.65c4.32-.52,4.47-14,4.47-15.59.06,1,.36,6.53.8,6.72a4.4,4.4,0,0,0,1.34-.37h0a12.91,12.91,0,0,1,0-2c0-.31.17.65.44,1.82l.78-.29a15.74,15.74,0,0,1,.07-4.2c.08-.53.41,1.79,1.08,3.78A52.8,52.8,0,0,1,299.1,58.6c1.08-.13,2-.19,2.84-.22-.13-1.62-.46-3.33-.31-3a15.71,15.71,0,0,1,.93,3h1.24c-.08-2.29-1.47-5.85-1.06-5.33a16.16,16.16,0,0,1,2.68,5.45c1.59.18,2,.45,2.05,0a19.13,19.13,0,0,0-6.78-11.35c-5.85-4.65-16.76-5-22.2,3.33,0,0-4.75,3.69-5.1,9S276.44,71.94,278.94,71.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.48,71.33s-4.19-5.17-6.57-3.64,1,9.21,4,10.08a2.94,2.94,0,0,0,3.83-1.86Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,69.87c-.05,0-.05.06,0,.07,2.09.68,3.29,2.49,4.18,4.39a1.62,1.62,0,0,0-2.46-.27.06.06,0,0,0,.06.1,1.84,1.84,0,0,1,2,.49,9.1,9.1,0,0,1,1.07,1.55c.11.18.43.06.34-.15l0,0C280,73.41,277.75,69.93,275,69.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,74a4.77,4.77,0,0,1-1.61,1.86,2.2,2.2,0,0,1-1.29.35c-1-.06-1.19-.92-1.17-1.7a5.2,5.2,0,0,1,.2-1.22A6.35,6.35,0,0,0,300.78,74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,61.84c-.41,0-.79-.09-1.2-.14a1.92,1.92,0,0,1-1.19-.38.62.62,0,0,1-.07-.76,1.56,1.56,0,0,1,1.48-.49,2.29,2.29,0,0,1,1.49.67A.66.66,0,0,1,304.39,61.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,63.27a9.5,9.5,0,0,0,1.15-.35,1.94,1.94,0,0,0,1.11-.58.63.63,0,0,0-.07-.76,1.52,1.52,0,0,0-1.54-.22,2.26,2.26,0,0,0-1.35.92A.66.66,0,0,0,292.38,63.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08,67.46s-.09.07-.08.11c.17,1.18.17,2.56-.86,3.07,0,0,0,.08,0,.07C295.44,70.38,295.43,68.55,295.08,67.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89,66.34c-1.92.07-1.64,3.9.13,3.84S295.49,66.29,293.89,66.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.15,66.6c-.32.24-.62.65-1,.72s-.84-.3-1.18-.66c0,0-.06,0-.06,0,0,.74.38,1.47,1.17,1.53s1.2-.64,1.33-1.39C293.41,66.7,293.28,66.5,293.15,66.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.47,66.38s.1.05.1.1c0,1.19.29,2.55,1.39,2.87,0,0,0,.07,0,.07C302.63,69.32,302.32,67.52,302.47,66.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,65.08c1.9-.27,2.29,3.55.53,3.8S301.86,65.3,303.46,65.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.28,65.24c.32.18.66.51,1,.5s.69-.46.91-.89c0,0,.06,0,.07,0,.09.73-.07,1.51-.76,1.73s-1.16-.39-1.41-1.1C304.07,65.39,304.15,65.18,304.28,65.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,76.52c.29.27.59.65,1,.67a3,3,0,0,0,1.27-.33,0,0,0,0,1,.05.06,1.58,1.58,0,0,1-1.49.68,1.25,1.25,0,0,1-1-1C296.19,76.51,296.28,76.48,296.32,76.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92,71.82s.39,1.75.46,2.58c0,.08-.19.14-.47.18,0,0,0,0,0,0a4,4,0,0,1-4-1.16c-.06-.07,0-.17.12-.12a6,6,0,0,0,3.71.73c0-.24-.77-3-.64-3a7.32,7.32,0,0,1,1.93.28c-.71-3.67-2-7.2-2.66-10.86a.11.11,0,0,1,.21-.07A60.72,60.72,0,0,1,302.93,72C303,72.42,301.26,71.93,300.92,71.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.3,360.79s23-5.2,35.54-16.79,19.61-32.36,19.61-32.36a196.65,196.65,0,0,0-25.74,6.76c-2.06,2.2-6,6.73-7.79,11a52.29,52.29,0,0,1-.06-7.87,35,35,0,0,0-8.18,5C399.25,335.63,396.3,360.79,396.3,360.79Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.12,321.73c3.13-2.16,6.31-4.25,9.43-6.44a.18.18,0,0,0-.19-.3c-5.92,3.53-11.75,7.31-17.39,11.26-2,1.38-3.9,2.81-5.81,4.28l.4-.68c.69-1.16,1.42-2.29,2.14-3.42a49,49,0,0,1,4.88-6.5c.06-.08-.05-.19-.12-.11-1.78,2.06-3.57,4.1-5.2,6.29-.78,1-1.49,2.11-2.18,3.21-.36.58-.7,1.15-1,1.74l-.35.59c-3,2.33-5.85,4.76-8.61,7.33q-2.56,2.38-4.93,4.93c.88-2.78,1.66-5.59,2.69-8.32a.08.08,0,1,0-.15,0c-1,2.87-2.1,5.75-2.87,8.7-1.76,1.9-3.44,3.86-5,5.91,0-.12.05-.25.08-.37.26-1.08.53-2.16.82-3.24.56-2.07,1.17-4.14,1.87-6.17a36,36,0,0,1,6.17-11.65c.06-.07-.05-.18-.12-.1-4.48,5.3-7.11,11.67-8.79,18.35-.24,1-.48,2-.7,2.94-.12.53-.25,1.06-.34,1.59-.7.94-1.38,1.89-2,2.86a99.84,99.84,0,0,0-9.71,19,221.06,221.06,0,0,0-7.36,22.94c0,.15.19.2.24,0,4.49-13.43,9.07-27,16.76-39.06a89.59,89.59,0,0,1,5.24-7.33,43.42,43.42,0,0,0,11.16-2.22,49.61,49.61,0,0,0,11.19-5.41,66.7,66.7,0,0,0,5.73-4.33.08.08,0,1,0-.1-.12,45.64,45.64,0,0,1-10.52,6.37,56.92,56.92,0,0,1-11.58,3.88c-1.69.37-3.41.65-5.13.88a94.27,94.27,0,0,1,6.77-7.5c.77-.77,1.57-1.51,2.37-2.26a53.69,53.69,0,0,1,8.49-4.86c3.76-1.82,7.46-3.75,11.18-5.64,2.1-1.07,4.19-2.16,6.31-3.19.09-.05,0-.18-.09-.14-3.77,1.83-7.6,3.53-11.41,5.27-3.58,1.64-7.21,3.29-10.65,5.22l-.43.26c3.11-2.7,6.33-5.28,9.62-7.77C430.89,326.15,434,323.9,437.12,321.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.81,333.57c-1.87.81-3.77,1.54-5.61,2.4s-3.71,1.93-5.51,3a.07.07,0,0,0,.07.12c1.83-.88,3.69-1.7,5.5-2.61s3.69-1.93,5.6-2.76C436,333.68,435.9,333.53,435.81,333.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.74,245.12a32.83,32.83,0,0,1,6.86,19.06c.07,2.06-.25,4.93-.49,8.3,8.56,4.57,15,12.8,15,12.8-4.86-2.92-11.54-4.1-15.14-3.62a45.38,45.38,0,0,0,.88,6.86c1.59-.09,4.66.12,9.73,1.92a21.81,21.81,0,0,0-8.77,1.75c4.09,13,16.25,26.39,49.83,32.07,0,0,6.48-22.8-5.94-47.26C363.61,257.2,321.74,245.12,321.74,245.12Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,380c-.58-5.56-1.32-11.11-2.18-16.63a328.75,328.75,0,0,0-6.77-32.88,130.21,130.21,0,0,0-4.85-15,21.93,21.93,0,0,0,.13-2.69c0-1.07,0-2.15,0-3.22,0-2.16-.12-4.3-.3-6.45a77.8,77.8,0,0,0-2.07-12.59c-.61-2.39-1.33-4.75-2-7.12a.08.08,0,0,0-.15.05A92.2,92.2,0,0,1,375.52,296a115.62,115.62,0,0,1,1.13,12.6c0,1.16.06,2.31.07,3.47,0,.49,0,1,0,1.48A108.7,108.7,0,0,0,371,301.86a142.71,142.71,0,0,0-11.5-17.2,7.49,7.49,0,0,0-.27-1.88c-.16-.75-.32-1.5-.49-2.25-.35-1.53-.73-3.06-1.15-4.57-.83-3-1.93-6-2.89-9a.08.08,0,0,0-.15,0c.89,3,1.48,6.06,2.16,9.09.34,1.49.67,3,1,4.49l.48,2.25,0,.17q-2-2.56-4.16-5.06c-6.42-7.52-13.45-14.46-20.52-21.35-.87-.85-1.77-1.67-2.65-2.51-.07-.07-.18,0-.11.12,6.77,7,13.43,14.19,19.73,21.66,1.5,1.78,3,3.57,4.43,5.39l-2.29-1.52c-2-1.28-3.94-2.52-6-3.66s-4.09-2.26-6.18-3.3-4.46-1.93-6.53-3.14c-.09-.05-.17.1-.08.14a47.63,47.63,0,0,1,6.13,3.39c2,1.21,4.08,2.43,6.09,3.71s4,2.48,5.92,3.76c1.63,1.06,3.24,2.22,4.94,3.2a159.63,159.63,0,0,1,10.76,15.66,116.67,116.67,0,0,1,5.56,10.55l-1.21-.53L369,308.16c-2-.88-4-1.73-5.94-2.6-3.77-1.63-7.6-3.14-11.29-4.94a51.34,51.34,0,0,1-6-3.34c-.08-.06-.16.08-.08.13,6.89,4.75,14.61,8.09,22.23,11.47l3.31,1.46c.91.4,1.81.85,2.75,1.2a117.52,117.52,0,0,1,5.68,15.56A317,317,0,0,1,387,359.59c1.92,11,3.22,22,4.23,33.11.13,1.38.25,2.76.41,4.14a.44.44,0,0,0,.87,0C392.41,391.19,391.84,385.55,391.25,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82,287.21c-.62-3.41-1.53-6.75-2.45-10.09,0-.1-.17-.06-.15,0,.85,3.28,1.46,6.63,2.08,10s1.18,6.8,1.66,10.22c0,.06.1.06.09,0A90.64,90.64,0,0,0,370.82,287.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.34,296.47a60.73,60.73,0,0,0-7.3-4.11c-1.22-.63-2.46-1.23-3.7-1.83s-2.61-1.14-3.88-1.78a.08.08,0,0,0-.07.14c1.22.62,2.39,1.36,3.6,2l3.72,2c2.46,1.32,4.87,2.78,7.45,3.85A.19.19,0,0,0,356.34,296.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.72,321s21.24-5.07,31-19.32c9.32-13.61,12.33-36.8,12.57-38.84-.39,1.87-4.77,22.14-19.23,31.58C410,301.69,399.28,307.64,396.72,321Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,284.33a27.17,27.17,0,0,0-7.84,12.9s.06.07.07,0a31.77,31.77,0,0,1,7.87-12.8C416.5,284.38,416.4,284.26,416.33,284.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.72,321s21.24-5.07,31-19.32c9.32-13.61,12.33-36.8,12.57-38.84a.86.86,0,0,0,0-.15s-10.18,14.48-20.89,18.18S393.65,297.36,396.72,321Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.54,270.71A86.93,86.93,0,0,1,430,281.94a44.85,44.85,0,0,1-8.74,9c-2.88,2.29-5.93,4.37-8.85,6.61l.06-.1c.55-.82,1.14-1.61,1.74-2.38,1.22-1.55,2.55-3,3.89-4.47,2.64-2.86,5.33-5.67,7.7-8.77a33,33,0,0,0,3.4-5.49c.05-.09-.1-.14-.15-.05-3.44,7.18-10.32,11.77-15.23,17.83-.7.87-1.36,1.76-2,2.69A11.69,11.69,0,0,0,410.6,299a44.37,44.37,0,0,0-7.24,7.32,28.68,28.68,0,0,1,.85-4.12,21,21,0,0,1,2.25-5.38c.05-.09-.08-.17-.13-.09a25.73,25.73,0,0,0-2.48,5.35,18.45,18.45,0,0,0-.77,4.58v0a41.77,41.77,0,0,0-2.87,4.46c.09-.45.17-.91.26-1.36.42-2.12.89-4.23,1.44-6.31a37.71,37.71,0,0,1,5.11-12c.06-.08-.07-.17-.13-.09a45.43,45.43,0,0,0-5.66,11.71c-.68,2.08-1.22,4.2-1.7,6.34-.23,1.05-.44,2.1-.64,3.15-.11.54-.22,1.1-.31,1.66a76.18,76.18,0,0,0-4.9,14.4,210.18,210.18,0,0,0-4.53,26.85A222.78,222.78,0,0,0,387.68,384c0,1.19.09,2.39.15,3.58,0,.31.48.35.49,0,.21-4.72.33-9.43.61-14.14s.69-9.42,1.2-14.11a251.58,251.58,0,0,1,4.42-27.46c1.73-7.77,4-15.59,8.2-22.39a41.84,41.84,0,0,1,7.67-9.11c3-2.68,6.23-5,9.37-7.49a52.19,52.19,0,0,0,8.6-8.27,67.79,67.79,0,0,0,6.76-11c.5-1,1-1.91,1.52-2.87C436.71,270.71,436.58,270.62,436.54,270.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.87,273.82a71.32,71.32,0,0,1-4.73,8.28c0,.06.05.12.1.06a57.33,57.33,0,0,0,4.78-8.29C433.06,273.78,432.91,273.73,432.87,273.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,311.64s-.34,30.18,17.71,38.9,27.72,1.45,40,4.37h0c-.47-.72-9.22-13.31-23.14-16.77C339,334.56,323.12,324.22,318.78,311.64Z",
    style: {
      fill: "#27D2FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,311.64s-.34,30.18,17.71,38.9,27.72,1.45,40,4.37h0a68.09,68.09,0,0,0-20.51-6.06C344.56,347.47,322.81,340.06,318.78,311.64Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.66,355.45a30.31,30.31,0,0,0-7.17-4.86c-.39-.19-.79-.34-1.18-.51-.19-.24-.4-.47-.61-.69-.54-.56-1.1-1.1-1.7-1.61a24.61,24.61,0,0,0-3.63-2.62c-3-1.76-6.26-3-9.32-4.62-.09-.05-.17.09-.08.13,1.51.79,3,1.65,4.45,2.51s2.89,1.63,4.28,2.53a31.08,31.08,0,0,1,3.57,2.68c.32.28.63.58.93.89a46.07,46.07,0,0,0-6.1-1.62c-3.3-.67-6.64-1.14-9.94-1.85a46.34,46.34,0,0,1-4.79-1.29c-1.5-1.21-3-2.4-4.41-3.71a36.91,36.91,0,0,1-4.67-5.17c-.06-.09-.19,0-.13.08a55.56,55.56,0,0,0,7.4,8.16q-1.17-.44-2.31-1a37.24,37.24,0,0,1-15.38-12.79c-.05-.08-.19,0-.13.08a42.18,42.18,0,0,0,12.44,12,38.19,38.19,0,0,0,7.86,3.72,74.17,74.17,0,0,0,9.77,2.31,68.27,68.27,0,0,1,9.57,2.27,29.19,29.19,0,0,1,8,4.22,37.51,37.51,0,0,1,10.81,13.41c3.42,6.85,5.05,14.51,6,22.07,0,.32.54.32.51,0C390.84,377.46,387.45,364.26,377.66,355.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.72,345.61a10.36,10.36,0,0,0-3.71-3.37,13.53,13.53,0,0,1-4.41-3.65c-.06-.08-.2,0-.14.08a14.93,14.93,0,0,0,3.9,3.49,13.64,13.64,0,0,1,4.25,3.51C356.66,345.74,356.77,345.68,356.72,345.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.3 377.73 367.12 394.32 369.63 445.04 407.5 445.04 410.01 394.32 410.83 377.73 366.3 377.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.3 377.73 367.12 394.32 410.01 394.32 410.83 377.73 366.3 377.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.64,
    y: 370.8,
    width: 49.85,
    height: 15.83,
    transform: "translate(777.13 757.43) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/CTA.25e7312ae5c6e186ad129308fc7c3066.svg";
export { ForwardRef as ReactComponent };